import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

const PrivacyPolicy = () => {
  const [text, setText] = useState("");

  useEffect(() => {
    import("md/privacy_policy.md").then((res) => {
      fetch(res.default)
        .then((res) => res.text())
        .then((res) => setText(res));
    });
  });

  return (
    <main className="text-main pad">
      <div className="container">
        <h3>Политика в отношении обработки персональных данных</h3>
        <ReactMarkdown children={text} />
      </div>
    </main>
  );
};

export default PrivacyPolicy;
